import React, { useEffect, useRef } from "react";

function InfiniteScrollObserver({
  onLoadMore,
  hasMore = true,
  root = null,
  rootMargin = "0px",
  threshold = 0,
}) {
  const loaderRef = useRef(null);

  useEffect(() => {
    if (!hasMore) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && hasMore) {
          onLoadMore();
        }
      },
      { root, rootMargin, threshold }
    );

    if (loaderRef.current) observer.observe(loaderRef.current);

    return () => {
      if (loaderRef.current) observer.unobserve(loaderRef.current);
    };
  }, [hasMore, onLoadMore]);

  return <div ref={loaderRef} style={{ height: 1 }} />;
}

export default InfiniteScrollObserver;
